export const classificationDropdownList = [
  { label: '제안서', value: 'proposal' },
  { label: '브로셔', value: 'brochure' },
  { label: '패치파일', value: 'patch_file' },
  { label: '설치파일', value: 'install_file' },
  { label: '가이드문서', value: 'guide' },
];
